<template>
  <page-view title="淘宝联盟账户">
    <div :style="{ marginBottom: '10px' }">
      <demo-video-alert name="LianMengPeiZhi"></demo-video-alert>
    </div>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="查询条件">
                <a-select v-model="queryParam.type" placeholder="请选择查询条件" allowClear>
                  <a-select-option value="1">账户ID</a-select-option>
                  <a-select-option value="2">淘宝联盟账户</a-select-option>
                  <a-select-option value="3">备注信息</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="查询内容">
                <a-input v-model="queryParam.keywords" placeholder="请输入查询内容" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="授权状态">
                <a-select v-model="queryParam.status" placeholder="请选择授权状态" allowClear>
                  <a-select-option value="1">已授权</a-select-option>
                  <a-select-option value="2">已过期</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced"></template>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator">
        <a-button type="primary" @click="handleAdd">新增联盟账户</a-button>
        <!-- <a-button type="danger" @click="$refs.drawMoney.show()">双十一赛马分奖</a-button> -->
        <!-- <a-button type="danger" @click="()=>{$message.error('暂未开放')}" disabled>双十一赛马分奖</a-button> -->
      </div>
      <s-table ref="table" size="default" rowKey="taobao_user_id" :columns="columns" :data="loadData">
        <div slot="remarks_text" slot-scope="text, record">{{ record.remark ? record.remark : '无' }}</div>
        <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="robot_num" slot-scope="text">
          <a>{{ text }}</a>
        </span>
        <span slot="auth_status" slot-scope="record">
          <a-badge :status="record.expire_time | statusTypeFilter" :text="record.expire_time | statusFilter" />
        </span>
        <span slot="is_sync" slot-scope="text, record">
          <a-switch checked-children="开" un-checked-children="关" :default-checked="text == 2"
            @change="e => handleSysChange(e, record.taobao_user_id)" />
        </span>
        <span slot="time" slot-scope="text">{{ parseInt(text) | moment }}</span>
        <span slot="action" slot-scope="text, record">
          <a @click="positionSync(record)">设置自定义推广位同步</a>
          <a-divider type="vertical" />
          <a @click="handleRefresh(record.id)">更新</a>
          <a-divider type="vertical" />
          <a @click="$refs.editModal.show(record.id)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm placement="top" @confirm="handleDelete(record.taobao_user_id)">
            <a-icon slot="icon" type="question-circle-o" style="color: red" />
            <template slot="title">
              <p>确定要删除？</p>
              <span>删除后机器人相关功能将失效！</span>
            </template>
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a @click="irregularOrders(record)">违规订单</a>
        </span>
      </s-table>
    </a-card>
    <edit-modal ref="editModal" @ok="$refs.table.refresh()"></edit-modal>
    <draw-money ref="drawMoney" @ok="$refs.table.refresh()"></draw-money>

    <!-- 	设置自定义推广位同步 -->
    <custom-promotion-space ref="cpSpace"></custom-promotion-space>
    <!-- 违规订单 -->
    <irregular-orders ref="iOrders"></irregular-orders>

  </page-view>
</template>

<script>
import { STable } from '@/components'
import CompanyApi from '@/api/company'
import { PageView } from '@/layouts'
import { mapGetters, mapActions } from 'vuex'
import EditModal from './modules/EditModal'
import DrawMoney from './modules/DrawMoney'
import CustomPromotionSpace from './modules/CustomPromotionSpace'
import IrregularOrders from './modules/IrregularOrders'

import DemoVideoAlert from '@/views/components/DemoVideoAlert'
import { openWin } from '@/utils/util'
const statusMap = {
  1: {
    status: 'processing',
    text: '正常',
  },
  3: {
    status: 'error',
    text: '已过期',
  },
}

export default {
  name: 'CompanyTaobaoList',
  components: {
    DrawMoney,
    PageView,
    STable,
    EditModal,
    DemoVideoAlert,
    CustomPromotionSpace,
    IrregularOrders
  },
  data() {
    return {
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          scopedSlots: { customRender: 'serial' },
        },
        {
          title: '淘宝联盟账户',
          dataIndex: 'taobao_user_nick',
        },
        {
          title: '账户ID',
          dataIndex: 'taobao_user_id',
        },
        {
          title: '授权状态',
          scopedSlots: { customRender: 'auth_status' },
        },
        {
          title: '同步订单',
          dataIndex: 'is_sync',
          scopedSlots: { customRender: 'is_sync' },
        },
        {
          title: '备注信息',
          scopedSlots: { customRender: 'remarks_text' },
        },
        {
          title: '到期时间',
          scopedSlots: { customRender: 'time' },
          dataIndex: 'expire_time',
          sorter: true,
        },
        {
          title: '操作',
          width: '220px',
          scopedSlots: { customRender: 'action' },
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return CompanyApi.getTaobaoList(Object.assign(parameter, this.queryParam))
      },
    }
  },
  filters: {
    statusFilter(expire_time) {
      const curTimestamp = new Date().getTime()
      let type
      if (expire_time > curTimestamp) {
        type = 1
      } else {
        type = 3
      }
      return statusMap[type].text
    },
    statusTypeFilter(expire_time) {
      const curTimestamp = new Date().getTime()
      let type
      if (expire_time > curTimestamp) {
        type = 1
      } else {
        type = 3
      }
      return statusMap[type].status
    },
  },
  created() { },
  methods: {
    ...mapActions(['demoSetVideo']),
    ...mapGetters(['userInfo']),

    toggleAdvanced() {
      this.advanced = !this.advanced
    },

    async handleSysChange(e, id) {
      CompanyApi.setSysTb({
        tb_user_id: id,
        status: e ? 2 : 0,
      })
    },

    handleAdd() {
      const id = this.userInfo().id
      window.open(
        'https://oauth.taobao.com/authorize?response_type=code&client_id=24665425&redirect_uri=https://admin.nianchu.net/api/5de8b73eb2157?isConfirm=1&state=NCNK_' +
        id +
        '&view=web',
        '_blank'
      )
      // openWin(
      //   `https://oauth.taobao.com/authorize?response_type=code&client_id=24665425&redirect_uri=https://admin.nianchu.net/api/5de8b73eb2157?isConfirm=1&state=NCNK_${id}&view=web`,
      //   "newwindow",
      //   900,
      //   500
      // )
      const that = this
      this.$confirm({
        title: '请在新窗口中登录淘宝账户完成授权',
        okText: '已完成授权',
        cancelText: '关闭',
        onOk() {
          that.$refs.table.refresh(true)
        },
      })
    },

    // 设置自定义推广位同步
    positionSync(record) {
      // console.log('设置自定义推广位同步=', record)
      this.$refs.cpSpace.show(record)
    },

    // 查看违规订单
    irregularOrders(item){
      this.$refs.iOrders.show(item)
    },

    handleRefresh() {
      const id = this.userInfo().id
      window.open(
        'https://oauth.taobao.com/authorize?response_type=code&client_id=24665425&redirect_uri=https://admin.nianchu.net/api/5de8b73eb2157?isConfirm=1&state=NCNK_' +
        id +
        '&view=web',
        '_blank'
      )

      // openWin(
      //   `https://oauth.taobao.com/authorize?response_type=code&client_id=24665425&redirect_uri=https://admin.nianchu.net/api/5de8b73eb2157?isConfirm=1&state=NCNK_${id}&view=web`,
      //   "newwindow",
      //   900,
      //   500
      // )
      const that = this
      this.$confirm({
        title: '请在新窗口中登录淘宝账户完成授权',
        okText: '已完成授权',
        cancelText: '关闭',
        onOk() {
          that.$refs.table.refresh()
        },
      })
    },

    handleDelete(id) {
      let loading = this.$message.loading('正在删除')
      CompanyApi.deleteTaobao({ union_id: id })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success('删除成功')
            this.$refs.table.refresh()
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.$message.destroy(loading)
        })
    },

  },
}
</script>
<style lang="less" scoped>
p {
  margin-bottom: 0;
  // text-align: center;
}

// .money_title {
//   font-weight: 700;
//   margin-bottom: 0;
// }
</style>
